import type { Path } from "react-router";

/**
 * Transforms a URLSearchParams object into a plain object.
 */
export function getSearchParams(urlSearchParams: URLSearchParams): {
  [key: string]: string | Array<string>;
} {
  return Array.from(urlSearchParams.entries()).reduce(
    (searchParams, [key, value]) => {
      return {
        // biome-ignore lint/performance/noAccumulatingSpread: This is a simple implementation
        ...searchParams,
        [key]: searchParams[key]
          ? Array.isArray(searchParams[key])
            ? [...searchParams[key], value]
            : [searchParams[key], value]
          : value,
      };
    },
    {} as { [key: string]: string | Array<string> },
  );
}

export function pathToString(path: Partial<Path>) {
  const hash = path.hash
    ? path.hash.startsWith("#")
      ? path.hash
      : `#${path.hash}`
    : "";
  const search = path.search
    ? path.search.startsWith("?")
      ? path.search
      : `?${path.search}`
    : "";

  return [path.pathname, search, hash].join("");
}
